import React from 'react';
import {changeWorkQueueSession} from '../../redux/reducers/WorkQueueList';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
const getIcon = (order) => {
  if (order === 'asc') {
    return <ArrowUpwardIcon className="sort-icon" />;
  } else if (order === 'desc') {
    return <ArrowDownwardIcon className="sort-icon" />;
  } else {
    return null;
  }
};
export const IconComponent = ({field}) => {
  const {workQueueNextAccount} = changeWorkQueueSession();
  const {orderBy, orderDirection} = workQueueNextAccount?.payload || {};
  if (orderBy && orderBy?.split('.')[1]?.toUpperCase() === field?.toUpperCase()) {
    return getIcon(orderDirection);
  }
  return null;
};
